import React, { useState } from 'react';
import { motion } from 'framer-motion';

const FloatingWhatsAppButton = ({ phoneNumber }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const handleWhatsAppClick = () => {
    // Create the pre-filled message
    const message = `Hi, I found you through the Vasudharini Homes website and would like to know more details about your available properties.`;
    
    // Format phone number (remove any spaces, dashes, or special characters except +)
    const cleanPhoneNumber = phoneNumber.replace(/[^\d+]/g, '');
    
    // Try different URL formats based on device/browser
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    let whatsappUrl;
    
    if (isMobile) {
      // For mobile devices, try the app-specific URL first
      whatsappUrl = `whatsapp://send?phone=${cleanPhoneNumber}&text=${encodeURIComponent(message)}`;
      
      // Fallback to web version if app is not installed
      setTimeout(() => {
        window.open(`https://api.whatsapp.com/send?phone=${cleanPhoneNumber}&text=${encodeURIComponent(message)}`, '_blank');
      }, 2000);
      
      window.location.href = whatsappUrl;
    } else {
      // For desktop, use web version
      whatsappUrl = `https://web.whatsapp.com/send?phone=${cleanPhoneNumber}&text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    }
    
    // For debugging - log the URL
    console.log('WhatsApp URL:', whatsappUrl);
  };
  
  return (
    <motion.div
      className="fixed bottom-24 right-6 z-50"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.4 }}
    >
      <motion.button
        className="group flex items-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg"
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 15 }}
      >
        {/* Circle with WhatsApp icon */}
        <div className="relative p-4 rounded-full">
          {/* WhatsApp SVG icon */}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="currentColor"
            className="relative z-10"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.63"/>
          </svg>
          <motion.div 
            className="absolute inset-0 bg-green-600 rounded-full"
            initial={{ scale: 0 }}
            animate={{ scale: isHovered ? 1 : 0 }}
            transition={{ duration: 0.3 }}
          />
        </div>
        
        {/* Text label that appears on hover */}
        <motion.div
          className="overflow-hidden"
          initial={{ width: 0, opacity: 0 }}
          animate={{ 
            width: isHovered ? 'auto' : 0,
            opacity: isHovered ? 1 : 0
          }}
          transition={{ duration: 0.3 }}
        >
          <span className="whitespace-nowrap pr-5 font-medium">
            Chat on WhatsApp
          </span>
        </motion.div>
      </motion.button>
    </motion.div>
  );
};

export default FloatingWhatsAppButton;